var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""}},[_c('template',{slot:"activator"},[_c('a',{staticClass:"secondary--text",on:{"click":_vm.submit}},[_vm._t("default")],2)]),_c('span',[_vm._v(_vm._s(_vm.tooltip))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }